export default __webpack_public_path__ + "static/media/TOYOTA.3f473ef1.png";